import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionRecordDrawer from '@/views/om/inspection/modules/InspectionRecordDrawer';
import SitePipeInspectionRecordDrawer from '@/views/base/modules/SitePipeInspectionRecordDrawer';
import { getAction, httpAction } from '@api/manage';
import { generateDayReport } from '@/api/api';
import moment from 'moment';
export default {
  data: function data() {
    return {
      date: '',
      dataList: [],
      pagePath: '/om/inspection/record',
      pagePath1: '/site/pipe/inspection/record'
    };
  },
  components: {
    InspectionRecordDrawer: InspectionRecordDrawer,
    SitePipeInspectionRecordDrawer: SitePipeInspectionRecordDrawer
  },
  mounted: function mounted() {
    this.date = moment();
    this.getData(moment().format('YYYY-MM-DD'));
  },
  methods: {
    onToDetail: function onToDetail(item) {
      var _this = this;

      console.log('id', item);

      switch (item.operationType) {
        case 1:
          getAction(this.pagePath + '/' + item.id).then(function (res) {
            if (res.success) {
              _this.$refs.modalForm.siteName = item.parentTitle;
              res.result.siteName = item.parentTitle;
              _this.$refs.modalForm.siteId = res.result.siteId;

              _this.$refs.modalForm.edit(res.result);

              _this.$refs.modalForm.title = '站点巡检单详情';
              _this.$refs.modalForm.disableSubmit = true;
              _this.$refs.modalForm.showTab = true;
              _this.$refs.modalForm.showContact = false;
            }
          });
          break;

        case 2:
          getAction(this.pagePath1 + '/' + item.id).then(function (res) {
            if (res.success) {
              res.result.pipeName = item.parentTitle;
              _this.$refs.modalPipeForm.pipeName = item.parentTitle;
              _this.$refs.modalPipeForm.pipeId = res.result.siteId;

              _this.$refs.modalPipeForm.edit(res.result);

              _this.$refs.modalPipeForm.title = '管网巡检单详情';
              _this.$refs.modalPipeForm.disableSubmit = true;
              _this.$refs.modalPipeForm.showTab = true;
              _this.$refs.modalPipeForm.showContact = false;
            }
          });
          break;
      }
    },
    getData: function getData(stimeStart) {
      var _this2 = this;

      this.dataList = [];
      generateDayReport({
        stimeStart: stimeStart
      }).then(function (res) {
        if (res.success) {
          var arr = [];
          res.result.forEach(function (item, index) {
            var obj = {
              title: item.title,
              childArr: []
            };
            item.siteDayReportVos.forEach(function (item1, index1) {
              if (item1.inspectionRecords.length == 0) {
                item1.inspectionRecords.push({
                  'category_dictText': '',
                  'stime': '',
                  'etime': '',
                  'status_dictText': '',
                  'userId_userName': ''
                });
              }

              item1.inspectionRecords.forEach(function (item2) {
                item2['parentTitle'] = item1.title, item2['parentLength'] = item1.inspectionRecords.length, obj.childArr.push(item2);
              });
            });

            for (var i = 0; i < obj.childArr.length; i++) {
              var item1 = obj.childArr[i];

              if (i == 0) {
                item1.show = true;
              } else {
                if (item1.parentTitle == obj.childArr[i - 1].parentTitle) {
                  item1.show = false;
                } else {
                  item1.show = true;
                }
              }
            }

            arr.push(obj);
          }); // this.dataList = res.result

          console.log('dataList', _this2.dataList);
          console.log('arr', arr);
          _this2.dataList = arr;
        }
      });
    },
    changeDataTime: function changeDataTime(e) {
      this.getData(e.format('YYYY-MM-DD'));
    }
  }
};